export default "__VITE_ASSET__D5l4KtHN__"